import { SCHEME_EXPAND } from './Menu.constants';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: [0, 'auto'],
    userSelect: 'none'
  },
  group: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  item: {
    display: 'block',
    lineHeight: 1,
    fontSize: 13,
    letterSpacing: '0.08em',
    textAlign: 'center',
    textTransform: 'none',
    textShadow: `0 0 5px ${theme.color.secondary.main}`,
    fontFamily: theme.typography.primary,
    color: theme.color.text.main,
    whiteSpace: 'nowrap'
  },
  divisor: {
    display: 'block',
    padding: [4, 6],
    color: theme.color.tertiary.main,
    textShadow: `0 0 5px ${theme.color.tertiary.main}`,
    fontWeight: 'normal',
    transform: 'scale(1, 0)',
    transformOrigin: 'center center'
  },
  groupDivisor: {
    display: 'none'
  },
  link: {
    padding: [4, 4],
    overflow: 'hidden',
    opacity: ({ scheme }) => scheme === SCHEME_EXPAND ? 0 : 1,
    transition: 'color 200ms ease, text-shadow 200ms ease',
    textDecoration: 'none',

    '&.link-active': {
      color: theme.color.secondary.light,
      textShadow: `0 0 10px ${theme.color.secondary.main}`
    },
    '&:hover, &:focus': {
      color: theme.color.secondary.light,
      textShadow: `0 0 10px ${theme.color.secondary.light}`
    }
  },

  '@media (min-width: 768px)': {
    root: {
      flexDirection: 'row'
    },
    groupDivisor: {
      display: 'block'
    },
    divisor: {
      padding: [8, 8]
    },
    link: {
      padding: [8, 6]
    }
  }
});

export { styles };

// Commit trace: 2026-03-29T13:25:03 - docs: update docstrings in Menu.styles.js
